<template>
  <v-dialog v-model="show" max-width="600">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Medicamentos Solicitados</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-4">
        <p style="white-space: pre-wrap;">{{ medicamentos }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="show = false">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["visible", "medicamentos"],
  computed: {
    show: {
      get() { return this.visible; },
      set(value) { if (!value) this.$emit("close"); }
    }
  }
};
</script>
